var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 0.666667C6.66667 0.298477 6.36819 0 6 0C5.63181 0 5.33333 0.298477 5.33333 0.666667V5.33333H0.666667C0.298477 5.33333 0 5.63181 0 6C0 6.36819 0.298477 6.66667 0.666667 6.66667H5.33333V11.3333C5.33333 11.7015 5.63181 12 6 12C6.36819 12 6.66667 11.7015 6.66667 11.3333V6.66667H11.3333C11.7015 6.66667 12 6.36819 12 6C12 5.63181 11.7015 5.33333 11.3333 5.33333H6.66667V0.666667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.d3b4f7cf3e75cc054450152bc54626ee.svg";
export { ForwardRef as ReactComponent };